export const userBaseUrl = process.env.REACT_APP_API_BASE_URL + "/api";
export const devBaseUrl = process.env.REACT_APP_API_BASE_URL + "/dev";
export const loginBaseUrl = process.env.REACT_APP_API_BASE_URL;
export const LOCAL = "http://localhost:8080";
export const LOCAL8081 = "http://localhost:8081";
